// Disable all inputs within a container.
ht.declare('.js-disableFormControls', function () {
  ht.toggleFormControls(this, {disable: true});
});
